document.addEventListener('DOMContentLoaded', function () {
  const thumbnailsSwiper = new Swiper ( '#product-gallery-thumbnails', {
    slidesPerView: 2.5,
    spaceBetween: 12,
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
      640: {
        slidesPerView: 2.5,
        spaceBetween: 16
      },
      768: {
        slidesPerView: 3.5,
        spaceBetween: 24
      }
    },
    pagination: {
        el: document.getElementById('product-gallery-thumbnails').querySelector('.swiper-pagination'),
        clickable: true,
        type: 'fraction',
      },
      navigation: {
        nextEl: document.getElementById('product-gallery-thumbnails').querySelector('.swiper-button-next'),
        prevEl: document.getElementById('product-gallery-thumbnails').querySelector('.swiper-button-prev')
      }
  });
  const mainSwiper = new Swiper ( '#product-gallery-swiper', {
    slidesPerView: 1,
    spaceBetween: 24,
    thumbs: {
      swiper: thumbnailsSwiper
    }
  });
});
